import { REUSE_NETWORK } from './mapConfig'
import reuseSitesData from '../data/reuseSites.json'
import type { ReuseSite, Site } from '../types'

const reuseSites = reuseSitesData as ReuseSite[]

// A pseudo-"site" for the AT Reuse Sites (independently-run sites, one aggregated
// marker + list entry). Shaped to match sites.json so it can flow through the same
// SitePanel/SiteMarker click machinery as a real site — see `subSites` for the sub-list.
export const REUSE_NETWORK_SITE: Site = {
  id: 'techowl-reuse-network',
  name: REUSE_NETWORK.name,
  org: 'Equipment Reuse',
  category: 'OTHER_AT',
  level1_function: 'Device Reuse Network',
  level2_access: 'Independently run — contact each site',
  region: 'Statewide',
  city: '',
  address: `${reuseSites.length} independently-run locations across Pennsylvania`,
  lat: REUSE_NETWORK.lat,
  lon: REUSE_NETWORK.lon,
  url: '',
  dataSource: 'inglis_website',
  audiences: {
    family: {
      headline: "What you'll find here",
      accessChip: 'Contact each site directly — hours and requirements vary',
      description: `${reuseSites.length} independently-run equipment-reuse programs across Pennsylvania — hospitals, Lions Clubs, churches, and community groups that redistribute mobility equipment, hearing aids, and other assistive devices, often at low or no cost.`,
      highlights: [
        'Each site is independently run — contact them directly for hours and how to get equipment',
      ],
      cta: 'Browse all sites below, or view them on the full interactive map',
    },
  },
  subSites: {
    mapUrl: REUSE_NETWORK.mapUrl,
    items: reuseSites,
  },
}
